import Sentry from 'modules/sentry';

import buildURL from './buildURL';
import appendJWTToken from './appendJWTToken';
import fetchWrapper from './fetchWrapper';
import trackResponseTime from './trackResponseTime';

import customNoAuthResponse from './customNoAuthResponse';

// import simulateApiDelay from './simulateApiDelay';
type ApiFetchOptions = import('modules/with-fetch').ApiFetchOptions;
type ApiResponse = import('modules/with-fetch').ApiResponse;

const apiFetch = async (
  opts: ApiFetchOptions,
): Promise<object | number | boolean> => {
  const {
    url,
    method,
    query,
    headers,
    body,
    timeoutMS = 30000,
    isFormData = false,
  } = opts;

  // Alek structured this, not sure why
  const jsonHeaders = isFormData
    ? {}
    : { Accept: 'application/json', 'Content-Type': 'application/json' };

  // Insert all the needed headers
  let fetchHeaders = {
    ...headers,
    ...jsonHeaders,
  };

  fetchHeaders = await appendJWTToken(fetchHeaders);

  // Alek made it this way, not sure why
  const fetchBody = isFormData ? body : JSON.stringify(body);

  // Build the fetch args object
  const fetchArgs = {
    method,
    body: fetchBody,
    headers: fetchHeaders,
    // credentials: 'include',
    // mode: 'cors', // https://developer.mozilla.org/en-US/docs/Web/API/Request/mode
  };

  const fullURL = buildURL({ url, query });

  let response: ApiResponse;
  // console.devLog.info('The full URL:', fullURL);
  // console.devLog.info('The full args:', fetchArgs);
  const startTime = new Date();
  try {
    response = await fetchWrapper(fullURL, fetchArgs, timeoutMS);

    // @ts-ignore ts doesn't like subtracting two JS date objects but it works fine
    const responseTime = new Date() - startTime;

    trackResponseTime(responseTime, {
      fullURL,
      fetchArgs,
    });
  } catch (error) {
    // console.devLog.info('An error occured:', error);
    // console.devLog.info('Error message?', error.message);
    if (
      !error.message.includes('Connection timed out') &&
      !error.message.includes('Network request failed')
    ) {
      Sentry.captureException(error, {
        extra: { ...opts },
      });
    }

    throw error;
  }

  Sentry.addBreadcrumb({
    message: 'apiFetch called and response received',
    category: 'apiFetch',
    data: { ...opts },
  });

  if (typeof response === 'object' && response.ok !== true) {
    const { status } = response;

    const errorStatusResponse = new Error(
      `Invalid server response (${status})`,
    );
    // @ts-ignore - this works correctly by appending a custom value onto the error code
    // https://medium.com/@xjamundx/custom-javascript-errors-in-es6-aa891b173f87
    errorStatusResponse.response = response;
    // Don't capture 401 errors from failed login attempts
    if (url !== 'MobileAccount/Login') {
      Sentry.captureException(errorStatusResponse, { extra: { ...opts } });
    }

    // Checks if the JWT token has expired and wipes out the token if so
    if (status === 401 && url !== 'MobileAccount/Login') {
      customNoAuthResponse(response);
    } else {
      throw errorStatusResponse;
    }
  }
  // console.devLog.info('Raw fetch response:', response);

  const dataJSON = await response.json();
  // console.devLog.info('JSON fetch response:', dataJSON);
  return dataJSON;
};

export default apiFetch;
